import { render, staticRenderFns } from "./ImportACSA.vue?vue&type=template&id=31f74fb4&scoped=true"
import script from "./ImportACSA.vue?vue&type=script&lang=js"
export * from "./ImportACSA.vue?vue&type=script&lang=js"
import style0 from "./ImportACSA.vue?vue&type=style&index=0&id=31f74fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f74fb4",
  null
  
)

export default component.exports